// Cocktail bar: neon sign glow behind the glass, with fine carbonation
// rising in tight columns and a slow sheen sweeping the bar top.
const FIZZ = [
  { x: 16, r: 0.7, delay: 0, dur: 4.2, opacity: 0.55 },
  { x: 19, r: 0.5, delay: 1.4, dur: 5.1, opacity: 0.4 },
  { x: 23, r: 0.6, delay: 2.6, dur: 4.6, opacity: 0.46 },
  { x: 44, r: 0.8, delay: 0.7, dur: 5.4, opacity: 0.5 },
  { x: 47, r: 0.5, delay: 2.1, dur: 4.4, opacity: 0.36 },
  { x: 51, r: 0.7, delay: 3.3, dur: 5.8, opacity: 0.42 },
  { x: 72, r: 0.6, delay: 1.1, dur: 4.9, opacity: 0.48 },
  { x: 75, r: 0.8, delay: 3.0, dur: 5.6, opacity: 0.38 },
  { x: 79, r: 0.5, delay: 0.4, dur: 4.3, opacity: 0.44 },
];

export default function AmbianceCocktailBarAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--cocktail"
      aria-hidden="true"
    >
      <span className="mode-tile__cocktail-neon" />
      <span className="mode-tile__cocktail-sheen" />
      <svg
        className="mode-tile__cocktail-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {FIZZ.map((bubble, index) => (
          <circle
            key={index}
            className="mode-tile__cocktail-fizz"
            cx={bubble.x}
            cy={42}
            r={bubble.r}
            style={{
              opacity: bubble.opacity,
              animationDelay: `-${bubble.delay}s`,
              animationDuration: `${bubble.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
